<template>
  <div class="activate-thanks tc" v-if="is_show">
    <p class="remind">Thank you for your registration!</p>
    <p class="remind">Let’s explore the Freelink Now!</p>
    <p class="return">
      <a href="javascript:void(0)" class="link" @click="toLogin">
        Return to Signin
      </a>
    </p>
  </div>
</template>

<script>
import userService from '../service/userService';
export default {
  data() {
    return {
      is_show: false,
      invalid: false,
    }
  },

  mounted(){
    this.getHash();
  },

  methods: {
    getHash() {
      let params = new URLSearchParams(location.search.substring(1));
      const hash = params.get("hash");
      if (hash) {
        userService.activate(hash)
        .then((res) => {
          if(res.status == 1){
            this.is_show = true;
          }
        })
        .catch((err) => {
          console.log(err)
          alert('invalid URL');
          this.$router.push({
            path: '/sign-in',
          })
        })
      }
    },

    toLogin: function () {
      this.$router.push({
        path: '/sign-in',
      })
    },
  },
}
</script>

<style></style>
